import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ServerValidationError } from '@/api/shared/types'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { ParkingService } from '../lib/parking.service'
import { ParkingSummary, TariffType } from '../lib/parking.types'

export const GET_SUMMARY = 'get-summary'

type Props = {
  type: TariffType
  from: string
  to: string
  autoNumber?: string
  isStandard?: boolean
  personalAccountId?: string
  enabled?: boolean
}

export const useSummary = ({
  type,
  from,
  to,
  enabled,
  autoNumber,
  isStandard,
  personalAccountId
}: Props) => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  return useQuery<ParkingSummary, AxiosError<ServerValidationError>>({
    queryKey: [GET_SUMMARY, projectId, type, from, to, personalAccountId],
    queryFn: () =>
      ParkingService.getSummary(
        projectId,
        type,
        from,
        to,
        autoNumber,
        isStandard,
        personalAccountId
      ),
    enabled: enabled ?? false
  })
}
